import React from 'react';
import { Panel } from 'react-bootstrap';
import '../../../css/flow/editor-help.less';

class FlowEditorHelp extends React.Component {

    constructor(props) {
        super(props);
        this.onToggle = this.onToggle.bind(this);
        this.state = { isVisible: false };
    }

    componentDidMount() {
        document.addEventListener('keydown', this.onToggle);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onToggle);
    }

    onToggle(e) {
        // CTRL + H
        if (e.ctrlKey && e.keyCode === 72 && this.props.isActive) {
            this.setState({ isVisible: !this.state.isVisible });
            e.preventDefault();
            return false;
        }
        return true;
    }

    render() {

        const classNames = ['shortcuts'];
        if (this.state.isVisible) {
            classNames.push('shortcuts-visible');
        }

        return (
            <Panel header="Help & Shortcuts" bsStyle="info" className={classNames.join(' ')}>
                <ul className="list-unstyled">
                    <li>
                        <span className="shortcut">Ctrl</span>
                        +
                        <span className="shortcut">H</span> 
                        : Open & Close Help
                    </li>
                    <li>
                        <span className="shortcut">Ctrl</span>
                        +
                        <span className="shortcut">Alt</span>
                        +
                        <span className="shortcut">C</span>
                        &nbsp;/&nbsp;
                        <span className="shortcut">Ctrl</span>
                        +
                        <span className="shortcut">Opt</span>
                        +
                        <span className="shortcut">C</span>
                        : Copy map element
                    </li>
                    <li>
                        <span className="shortcut">Ctrl</span>
                        +
                        <span className="shortcut">Alt</span>
                        +
                        <span className="shortcut">V</span>
                        &nbsp;/&nbsp;
                        <span className="shortcut">Ctrl</span>
                        +
                        <span className="shortcut">Opt</span>
                        +
                        <span className="shortcut">V</span>
                        : Paste map element
                    </li>
                    <li>
                        <span className="shortcut">Ctrl</span>
                        +
                        <span className="shortcut">A</span> 
                        : Select all elements
                    </li>
                    <li>
                        <span className="shortcut">Ctrl</span>
                        +
                        <span className="shortcut">F</span>
                        : Find elements in the Flow
                    </li>
                    <li>
                        <span className="shortcut">Ctrl</span>
                        +
                        <span className="shortcut">P</span>
                        : Print Flow to HTML
                    </li>
                    <li>
                        <span className="shortcut">Ctrl</span>
                        +
                        <span className="shortcut">Left Mouse</span>
                        : Highlight directly connected elements
                    </li>
                    <li>
                        <span className="shortcut">Shift</span>
                        +
                        <span className="shortcut">Left Mouse</span>
                        : Open element metadata
                    </li>
                    <li>
                        <span className="shortcut">Ctrl</span>
                        +
                        <span className="shortcut">Shift</span> 
                        + 
                        <span className="shortcut">Left Mouse</span>
                        : Highlight path of connected elements
                    </li>
                    <li>
                        <span className="shortcut">Shift</span>
                        +
                        <span className="shortcut">F</span>
                        : Zoom to fit Graph
                    </li>
                    <li>
                        <span className="shortcut">Ctrl</span>
                        +
                        <span className="shortcut">M</span>
                        : Show & Hide map elements
                    </li>
                    <li>
                        <span className="shortcut">Ctrl</span>
                        +
                        <span className="shortcut">Left Mouse</span>
                        +
                        <span className="shortcut">Drag</span> 
                        : Select multiple map elements
                    </li>
                    <li>
                        <span className="shortcut">Left Mouse</span>
                        : Pan the graph
                    </li>
                    <li>
                        <span className="shortcut">Right Mouse</span> 
                        : Select elements in the graph
                    </li>
                </ul>
            </Panel>
        );

    }

}

export default FlowEditorHelp;
